export const footerLinks = [
    {
        title: 'Com arribar a la seu de l\'AMB',
        url: 'http://www.amb.cat/s/web/amb/com-arribar.html',
    },
    {
        title: 'Contacte',
        url: 'http://www.amb.cat/web/amb/seu-electronica/suggeriments-i-queixes',
    },
    {
        title: 'Accesibilitat',
        url: 'http://www.amb.cat/s/web/amb/accessibilitat.html',
    },
    {
        title: 'Avís Legal',
        url: 'http://www.amb.cat/s/web/amb/avis-legal.html',
    },
    {
        title: 'Política de privacitat',
        url: 'http://www.amb.cat/s/web/amb/politica-de-privacitat.html',
    },
    {
        title: 'Premis i mencions',
        url: 'http://www.amb.cat/web/amb/premis-i-mencions',
    },
];
